import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'account-confirmation-expired',
  templateUrl: './account-confirmation-expired.component.html',
  styles: ['.loginbox { min-width: 320px; max-width: 360px; margin: 0 auto;}']
})
export class AccountConfirmationExpiredComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }
  // backHome() {
  //   this.router.navigate(['']);
  // }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/account/account-confirmation-expired.component.ts